//---------------------------------------------
// Turmas Module 
//---------------------------------------------
// Módulo para gerenciar as ações das turmas

import axios from '../../services/api';
import Cookies from 'js-cookie';
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    listTurmas: [],

    //VERIFICACAO DE ERRO
    isCreateTurmaCSV: false,
    isTurmaCreated: false
})

// MUTATIONS
const mutations = {
    //-- MUTATION REQUISICAO DO LISTTURMAS
    setListTurmas(state, payload) {
        state.listTurmas = payload
    },

    setIsCreateTurmaCSV(state, payload) {
        state.isCreateTurmaCSV = payload
    },

    setIsTurmaCreated(state, payload){
        state.isTurmaCreated = payload;
    }
}

// ACTIONS
const actions = {
     //-- ACTION REQUISICAO DE CRIAR TURMA
    async setCreateTurma({ commit }, payload)  {
        await axios
            .post(`turmas/${payload.idMunicipio}/${payload.idUnidade}`, {
                nome: payload.nome,
                codigoTurma: payload.codigoTurma,
                tipoPeriodo: payload.tipoPeriodo,
                tipoIdade: payload.tipoIdade,
                tipoTurma: payload.tipoTurma,
                idMunicipio: payload.idMunicipio,
                idUe: payload.idUnidade,
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsTurmaCreated', true);
            })
            .catch((error) => {
                commit('setIsTurmaCreated', false);
                console.log(error.message)
            });
    },

    //-- ACTION REQUISICAO DE ENVIAR ARQUIVO PARA CRIAR TURMA
    async setSendClassFile( {commit}, payload)  {
        var formData = new FormData();
        if (payload.file) {
            formData.append("file", payload.file)
        }
        await axios
            .post(`turmas/upload/${payload.idInstituicao}/${payload.idUnidade}`, 
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsCreateTurmaCSV', true)
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsCreateTurmaCSV', false)
            })
    },

    //-- ACTION REQUISICAO DO LISTTURMAS
    async setListTurmas({ commit }, payload) {
        await axios
            .get(`turmas/${payload.idMunicipio}/${payload.idUnidade}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListTurmas', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION DELETE TURMA
    async deleteTurma(_, payload) {
        await axios
            .delete(`turmas/${payload.idInstituicao}/${payload.idUE}/${payload.idTurma}`, {

            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))
    },
}

// GETTERS
const getters = {
    getListTurma(state) {
        try {
            return state.listTurmas.data
        } catch (e) {
            return []
        }
    },

    getIsCreateTurmaCSV(state) {
        return state.isCreateTurmaCSV
    },
    getIsTurmaCreated(state) {
        return state.isTurmaCreated;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
